"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { useState } from "react";
import s from "./Image.module.css";
const loadedSrcs = new Set();
export const Image = ({ src, className, draggable = false, onLoad, onError, forceRenderAfterLoadFail = false, ...restProps }) => {
    const [loaded, setLoaded] = useState(() => src && loadedSrcs.has(src));
    const [failed, setFailed] = useState(false);
    const considerLoaded = loaded || (failed && forceRenderAfterLoadFail);
    if (!src || (!forceRenderAfterLoadFail && failed)) {
        return null;
    }
    return (_jsx("img", { ...restProps, src: src, className: clsx(s.Image, className), onLoad: (evt) => {
            setLoaded(true);
            loadedSrcs.add(src);
            onLoad?.(evt);
        }, onError: (evt) => {
            setFailed(true);
            onError?.(evt);
        }, "data-loaded": considerLoaded ? "" : undefined, draggable: draggable }));
};
//# sourceMappingURL=Image.js.map